// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-wrapper {
  width: 450px;
  height: 70%;
  position: fixed;
  z-index: 99;
  bottom: 130px;
  right: 22px;
}

.card-footer {
  background: #fff;
  border: none;
  padding: 20px;
}

.card-footer .arrow-up {
  position: absolute;
  right: 28px;
  bottom: 27px;
  padding: 0px 4px;
}

.suggestion-container {
  padding: 8px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,.125);
  font-size: 14px;
  cursor: pointer;
}

.suggestion-container:hover {
  background: rgba(0,0,0,0.03);
}

.suggestion-container .title {
  font-weight: 500;
}

.suggestion-container .description {
  color: #727272;
}

.message-wrap {
  max-width: 80%;
  width: auto;
  background: #dadada;
  border-radius: 10px;
  padding: 10px;
  white-space: pre-line;
}
  
.message-wrap .profile-img {
  border-radius: 4px;
  margin-right: 6px;
}

:host .btn:disabled {
  opacity: 0.2;
}

.options-wrap {
  max-width: 80%;
  width: auto;
}

.options-wrap span {
  border-radius: 20px;
  border: 1px solid gray;
  cursor: pointer;
}

.betaTag {
  color: red;
}

:host ::ng-deep popover-container {
  background: rgba(97,97,97,.9);
}

:host ::ng-deep .popover-arrow.arrow {
  display: none;
}

:host ::ng-deep .popover-content.popover-body {
  color: #fff;
}

@media (max-width: 640px) {
  .chip-width {
    width: 100% !important;
    padding: 0 0 6px 0 !important;
  }
  .main-wrapper {
    width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/lexie-ai-chatbot/lexie-ai-chatbot.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".main-wrapper {\n  width: 450px;\n  height: 70%;\n  position: fixed;\n  z-index: 99;\n  bottom: 130px;\n  right: 22px;\n}\n\n.card-footer {\n  background: #fff;\n  border: none;\n  padding: 20px;\n}\n\n.card-footer .arrow-up {\n  position: absolute;\n  right: 28px;\n  bottom: 27px;\n  padding: 0px 4px;\n}\n\n.suggestion-container {\n  padding: 8px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,.125);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.suggestion-container:hover {\n  background: rgba(0,0,0,0.03);\n}\n\n.suggestion-container .title {\n  font-weight: 500;\n}\n\n.suggestion-container .description {\n  color: #727272;\n}\n\n.message-wrap {\n  max-width: 80%;\n  width: auto;\n  background: #dadada;\n  border-radius: 10px;\n  padding: 10px;\n  white-space: pre-line;\n}\n  \n.message-wrap .profile-img {\n  border-radius: 4px;\n  margin-right: 6px;\n}\n\n:host .btn:disabled {\n  opacity: 0.2;\n}\n\n.options-wrap {\n  max-width: 80%;\n  width: auto;\n}\n\n.options-wrap span {\n  border-radius: 20px;\n  border: 1px solid gray;\n  cursor: pointer;\n}\n\n.betaTag {\n  color: red;\n}\n\n:host ::ng-deep popover-container {\n  background: rgba(97,97,97,.9);\n}\n\n:host ::ng-deep .popover-arrow.arrow {\n  display: none;\n}\n\n:host ::ng-deep .popover-content.popover-body {\n  color: #fff;\n}\n\n@media (max-width: 640px) {\n  .chip-width {\n    width: 100% !important;\n    padding: 0 0 6px 0 !important;\n  }\n  .main-wrapper {\n    width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
